import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allEmails: [],
  openFilter: false,
};

const EmailSlice = createSlice({
  name: "EmailSlice",
  initialState,
  reducers: {
    setAllEmails: (state, action) => {
      state.allEmails = action.payload;
    },
    setOpenFilter: (state) => {
      state.openFilter = !state.openFilter;
    },
  },
});
export const { setAllEmails, setOpenFilter } = EmailSlice.actions;

export default EmailSlice.reducer;
